import { LOGOUT } from 'auth/constants'
import { CANCELED_WAITING_LIST } from 'grs/constants'

import * as constants from './constants'

export function dashboardRecentTransactions(state = [], { type, reservations, waitingListKey }) {
    switch (type) {
        case constants.SET_RESERVATIONS:
            return reservations

        case CANCELED_WAITING_LIST:
            return state.filter(id => id !== waitingListKey)

        case LOGOUT:
            return []

        default:
            return state
    }
}

export const dashboardRecentNews = (state = [], action) =>
    action.type === constants.SET_RECENT_NEWS ? action.news : state
